import React, { useEffect, useContext } from 'react'
import { Row, Col, CardBody, Card, Container } from 'reactstrap'

// Redux
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'

// availity-reactstrap-validation
import { AvForm, AvField } from 'availity-reactstrap-validation'

// actions
import { loginUser, apiError } from '../../store/actions'

// import images
import profile from '../../assets/images/profile-img.png'
import logo from '../../assets/images/logo.svg'
import toastr from 'toastr'
import { GeneralContext } from '../../context/'

const Login = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    useEffect(() => {
        window.analytics.page('Login Page Viewed')
        props.apiError('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const { error } = props

        if (error) {
            toastr.error('Usuario/Password incorrecto', `Oop's`)
            props.apiError('')
        }

        setLoading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const handleValidSubmit = (event, values) => {
        setLoading(true)
        window.analytics.track("Login attempt", { email: values.email })
        props.loginUser(values, props.history)
    }

    return (
        <React.Fragment>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="bx bx-home h2"></i>
                </Link>
            </div>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                <div className="bg-soft-primary">
                                    <Row>
                                        <Col className="col-7">
                                            <div className="text-primary p-4">
                                                <h5 className="text-primary">
                                                    ¡Bienvenido/a!
                                                </h5>
                                                <p>
                                                    Inicia Sesión en tu
                                                    Cuenta Vendora.
                                                </p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img
                                                src={profile}
                                                alt=""
                                                className="img-fluid"
                                            />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div>
                                        <Link to="/">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={logo}
                                                        alt=""
                                                        className="rounded-circle"
                                                        height="34"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">
                                        <AvForm
                                            className="form-horizontal"
                                            onValidSubmit={ handleValidSubmit }
                                        >
                                            <div className="form-group">
                                                <AvField
                                                    id="email"
                                                    name="email"
                                                    label="Whatsapp o Email"
                                                    value=""
                                                    className="form-control"
                                                    placeholder=""
                                                    type="text"
                                                    required
                                                />
                                            </div>

                                            <div className="form-group">
                                                <AvField
                                                    id="password"
                                                    name="password"
                                                    label="Password"
                                                    value=""
                                                    type="password"
                                                    required
                                                    placeholder="******"
                                                />
                                            </div>

                                            <div className="mt-3">
                                                <button
                                                    className="btn btn-primary btn-block waves-effect waves-light"
                                                    type="submit"
                                                >
                                                    Log In
                                                </button>
                                            </div>

                                            <div className="mt-4 text-center">
                                                <Link
                                                    to="/forgot-password"
                                                    className="text-muted"
                                                    onClick={() => {
                                                        window.analytics.track("Go to Password Recovery")
                                                    }}
                                                >
                                                    <i className="mdi mdi-lock mr-1"></i>{" "}
                                                    Recuperar Contraseña
                                                </Link>
                                            </div>
                                        </AvForm>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>
                                    ¿Aún no eres Vendora?{" "}
                                    <Link
                                        to="/registrar"
                                        className="font-weight-medium text-primary"
                                        onClick={() => {
                                            window.analytics.track("Login Initiated")
                                        }}
                                    >
                                        {" "}
                                        Quiero ser Vendora{" "}
                                    </Link>{" "}
                                </p>
                                <p>
                                    © {new Date().getFullYear()} Vendora, Inc.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    const { error } = state.Login
    return { error }
}

export default withRouter(
    connect(mapStatetoProps, { loginUser, apiError })(Login)
)
